import React, { useState, useRef, useEffect, forwardRef } from "react";
import { SvgIcon } from "../../containers/Shared";
import { disable } from "ol/rotationconstraint";

export const QISimpleSearch = forwardRef(
  (
    {
      searchKey,
      handleSearchChange,
      simpleSearchPlaceholder = "Search",
      handleSearchSwitch,
      handleAdvanceSearchKeys,
      setDetails,
      setDockAlign,
      setDeviceId = () => {},
      tracking = false,
      handleSearchClear = () => {},
      handleAdvanceSearchToggle,
      showAdvanceSearch,
      disabled,
    },
    ref
  ) => {
    const [showSearchParams, setShowSearchParams] = useState(false);
    const searchParamsRef = useRef(null);
    const inputRef = useRef(null);
    const wrapperRef = useRef(null);

    // Parse placeholder text to extract search parameters
    const searchParams = simpleSearchPlaceholder
      .split(",")
      .map((param) => param.trim())
      .filter((param) => param);

    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
      } else if (e.key === "Escape") {
        setShowSearchParams(false);
      }
    };

    const handleClickOutside = (event) => {
      if (
        searchParamsRef.current &&
        !searchParamsRef.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.contains(event.target)
      ) {
        setShowSearchParams(false);
      }
    };

    useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    // Hide tooltip when searchKey is not empty
    useEffect(() => {
      if (searchKey && searchKey.length > 0) {
        setShowSearchParams(false);
      }
    }, [searchKey]);

    const toggleSearchParams = () => {
      if (tracking && (!searchKey || searchKey.length === 0)) {
        setShowSearchParams(!showSearchParams);
      }
    };

    // Create a simple string of parameters
    const paramsString = searchParams.join(", ");

    return (
      <>
        <form
          ref={ref}
          className="search-form"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <div className="qi-input qi-form-element">
            <SvgIcon
              wrapperClass="icons-wrapper search-icon"
              svgClass="icon icon-search"
              name="search"
            />

            <div className="qi-input_wrapper" ref={wrapperRef} style={{ position: "relative" }}>
              <input
                ref={inputRef}
                className={`qi-input_text ${disabled ? "disabled" : ""}`}
                onChange={(e) => {
                  handleSearchChange(e.target.value);
                  if (e.target.value) {
                    setShowSearchParams(false);
                  }
                }}
                onKeyDown={handleKeyDown}
                onClick={toggleSearchParams}
                value={searchKey}
                type="search"
                title={!disabled ? simpleSearchPlaceholder : "Search is disabled"}
                placeholder={!tracking ? simpleSearchPlaceholder : "Search"}
                autoFocus
                disabled={disabled}
              />

              {tracking && showSearchParams && searchParams.length > 0 && !searchKey && (
                <div
                  ref={searchParamsRef}
                  style={{
                    position: "absolute",
                    top: "calc(100% + 5px)",
                    left: 0,
                    backgroundColor: "#ffffff",
                    border: "1px solid #ccc",
                    padding: "10px",
                    zIndex: 9999,
                    width: "100%",
                    boxSizing: "border-box",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                    fontSize: "12px",
                    lineHeight: "1.4",
                    height: "fit-content",
                  }}
                >
                  <p className="search-by-guideline">By {paramsString.toLocaleLowerCase()}</p>
                </div>
              )}
            </div>

            {searchKey && (
              <button
                className="qi-btn secondary sm"
                onClick={(e) => {
                  handleSearchChange("");
                  setTimeout(() => {
                    setDeviceId(null);
                    setDetails?.(false);
                    setDockAlign?.("cross");
                  }, 100);
                }}
              >
                clear
              </button>
            )}

            {handleAdvanceSearchToggle && (
              <SvgIcon
                wrapperClass={`clickable filter-icon ${showAdvanceSearch ? "active" : ""}`}
                svgClass="icon-filter"
                name="filter"
                onClick={handleAdvanceSearchToggle}
                title="Advanced Filter"
              />
            )}
            {handleAdvanceSearchKeys && (
              <SvgIcon
                wrapperClass="clickable filter-icon"
                svgClass="icon-filter"
                name="filter"
                onClick={handleSearchSwitch}
                title="Filter"
              />
            )}
          </div>
        </form>
      </>
    );
  }
);
